import { render, staticRenderFns } from "./addclaimc.vue?vue&type=template&id=7fc21d4a&scoped=true&"
import script from "./addclaimc.vue?vue&type=script&lang=js&"
export * from "./addclaimc.vue?vue&type=script&lang=js&"
import style0 from "./addclaimc.vue?vue&type=style&index=0&id=7fc21d4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc21d4a",
  null
  
)

export default component.exports